var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableVideoActiveLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40.5,
    r: 40,
    fill: "rgba(35, 40, 52, 1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.071 36.2359V43.7643C28.071 45.1137 28.6747 46.3211 29.6158 47.1199L44.1487 32.587C43.4296 32.0898 42.5596 31.7969 41.6274 31.7969H32.5098C30.0595 31.7969 28.071 33.7856 28.071 36.2359Z",
    fill: "rgba(255, 255, 255, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6693 27.8307C52.3231 27.4845 51.7605 27.4845 51.4142 27.8307L28.3318 50.9131C27.9856 51.2593 27.9856 51.822 28.3318 52.1682C28.5049 52.3424 28.7313 52.429 28.9588 52.429C29.1863 52.429 29.4127 52.3424 29.5869 52.1693L33.5531 48.2031H41.6287C44.0701 48.2031 46.0676 46.2145 46.0676 43.7642V43.3114L50.2403 45.815C50.7996 46.1523 51.4655 46.1612 52.0336 45.8416C52.5918 45.522 52.9292 44.945 52.9292 44.2969V35.7031C52.9292 35.0551 52.5918 34.478 52.0325 34.1584C51.4643 33.8388 50.7985 33.8476 50.2392 34.185L46.0665 36.6886V36.2358C46.0665 36.0649 46.041 35.9006 46.021 35.7342L52.6693 29.0859C53.0155 28.7396 53.0156 28.1781 52.6693 27.8307Z",
    fill: "rgba(255, 255, 255, 1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(28 27.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableVideoActiveLight);
export default __webpack_public_path__ + "static/media/DisableVideoActiveLight.5491cf35da71f4eb0bb6750345a58d59.svg";
export { ForwardRef as ReactComponent };